import { render } from "./view-as-button.vue?vue&type=template&id=52ae01e4&lang=pug"
import script from "./view-as-button.vue?vue&type=script&setup=true&lang=js"
export * from "./view-as-button.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__